// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__De3mC","ellipsis":"styles_ellipsis__NsE7x","text2AndMoreLines":"styles_text2AndMoreLines__Gi0tK","tooltipTrigger":"styles_tooltipTrigger__1l_08"};